import type { ImpressionViewAncillariesItem } from '@/scopes/checkout/domain/analytics/types'
import type { CheckoutAnalyticsStep } from '@/scopes/checkout/domain/types/bookingDraft'
import type { AvailableRooms, UpdateRoomSelectionPayload } from '@/scopes/checkout/groups/domain/types/availableRooms'

const GA4_ITEM_CATEGORY = 'Ancillary > groups > selectRoom'
const GA4_ITEM_CATEGORY2 = 'selectRoom'

/**
 * Maps a room selection payload to a GA4 select_item item.
 * Handles 3 cases: specific named room, new room creation, and random allocation.
 * Returns null if the payload does not represent a valid selection.
 */
export function mapRoomSelectionToGA4Item(
  payload: UpdateRoomSelectionPayload,
  availableRooms: AvailableRooms | undefined,
  analytics: CheckoutAnalyticsStep | undefined,
): (ImpressionViewAncillariesItem & { index: number }) | null {
  const step = analytics?.step ?? 1
  const itemListName = `checkout${step}`

  if (payload.assignationMethod === 'random') {
    return {
      item_name: 'random',
      item_id: 'random',
      price: 0,
      item_category: GA4_ITEM_CATEGORY,
      item_category2: GA4_ITEM_CATEGORY2,
      item_list_name: itemListName,
      quantity: '1',
      index: 1,
    }
  }

  if (payload.isNewRoom) {
    if (!payload.name || !payload.type)
      return null

    return {
      item_name: payload.name,
      item_id: payload.type,
      price: 0,
      item_category: GA4_ITEM_CATEGORY,
      item_category2: GA4_ITEM_CATEGORY2,
      item_list_name: itemListName,
      quantity: '1',
      index: 1,
    }
  }

  if (!payload.roomId)
    return null

  const room = availableRooms?.rooms?.[payload.roomId]
  const itemName = room?.name ?? payload.name ?? payload.roomId

  return {
    item_name: itemName,
    item_id: room?.roomType ?? payload.roomId,
    price: 0,
    item_category: GA4_ITEM_CATEGORY,
    item_category2: GA4_ITEM_CATEGORY2,
    item_list_name: itemListName,
    quantity: '1',
    index: 1,
  }
}
